module.exports = __webpack_public_path__ + "static/media/register3.573063ad.svg";